import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import utils from 'src/js/modules/utils';
import helpers from '../helpers';
import constants from '../constants';

const { Stack, ControlGroup, CheckboxField, InputGroupField } = designSystem;

const { createRequiredValidator } = utils.validators;
const {
  common: { LABEL_INPUT, PLACEHOLDER_INPUT },
  fieldControlNames,
} = constants;

const BasicFieldControls = ({ control, placeholders, onChangeRequiredFieldControl }) => {
  const validateRequiredField = createRequiredValidator(i18next.t('This field is required'));

  return (
    <Stack gap="spacing-m">
      <ControlGroup title={i18next.t('Label')} required>
        <InputGroupField
          name={fieldControlNames.LABEL}
          control={control}
          placeholder={placeholders[LABEL_INPUT]}
          rules={{
            validate: (value) =>
              validateRequiredField(value) || helpers.validatePersonalData(value),
          }}
        />
      </ControlGroup>
      <ControlGroup title={i18next.t('Placeholder')}>
        <InputGroupField
          name={fieldControlNames.PLACEHOLDER}
          control={control}
          placeholder={placeholders[PLACEHOLDER_INPUT]}
          rules={{
            validate: helpers.validatePersonalData,
          }}
        />
      </ControlGroup>
      <CheckboxField
        name={fieldControlNames.REQUIRED}
        control={control}
        label={i18next.t('Make required')}
        onChange={onChangeRequiredFieldControl}
      />
    </Stack>
  );
};

BasicFieldControls.propTypes = {
  control: PropTypes.shape({}).isRequired,
  placeholders: PropTypes.shape({
    [LABEL_INPUT]: PropTypes.string,
    [PLACEHOLDER_INPUT]: PropTypes.string,
  }).isRequired,
  onChangeRequiredFieldControl: PropTypes.func.isRequired,
};

export default BasicFieldControls;
